import { ThreadsView } from "views/Threads";

export type Page = "outercom-threads";

export const pageMap: Record<Page, JSX.Element> = {
  "outercom-threads": <ThreadsView />,
};

export const isPage = (x: string): x is Page => x in pageMap;
